import { GetApp } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { downloadFile } from "../../../../../utils/filesUtils";
import FeatureLabel from "../../../../commons/labels/FeatureLabel";
import { StyledImportIetError } from "../../../../styled/form";

const ImportIetError = ({ handleExit, handleReset, file }) => {
  return (
    <StyledImportIetError.PaperContainer>
      <div>
        <StyledImportIetError.TypographyContainer>
          <Typography variant="h6">Errores de Importación</Typography>
        </StyledImportIetError.TypographyContainer>
        {file ? (
          <FeatureLabel
            labelText="REGISTROS IET A CORREGIR"
            icon={<GetApp />}
            onClick={() =>
              downloadFile(
                file,
                `Registros Iet con Errores ${format(
                  new Date(),
                  "dd-MM-yyyy",
                )}.csv`,
              )
            }
            tooltipText="Descargar archivo"
          />
        ) : null}
        <StyledImportIetError.ButtonContainer>
          <Button variant="contained" color="primary" onClick={handleReset}>
            Reintentar
          </Button>
          <StyledImportIetError.ExitButton
            variant="outlined"
            onClick={handleExit}>
            Salir
          </StyledImportIetError.ExitButton>
        </StyledImportIetError.ButtonContainer>
      </div>
    </StyledImportIetError.PaperContainer>
  );
};

export default ImportIetError;
